module.exports = __webpack_public_path__ + "img/sumologic.bf47f505.png";